
export default {
  // 修改视口宽度
  async setVW({ commit }, data) {
    commit('SET_VW', data)
  },
  // 修改语言
  async setLang({ commit }, data) {
    commit('SET_LANG', data)
  },
}
